<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span class='bid_item_title'>友情链接</span>
      <!-- <el-button class="bid_more" type="text">更多<i class="el-icon-arrow-right el-icon--right"></i></el-button> -->
    </div>
    <div v-for="(lItem,index) in linkArr" :key="index" class="bid_note_item">
      <el-row>
        <el-col :span="24">
          <el-link :href="lItem.link" target="_blank" :underline="false">
            <span class="bid_link_name">{{lItem.name}}</span>
          </el-link>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>
<script>
export default {
  data() {
    return {
      linkArr: [
        {
          name: '中国招标投标公共服务平台',
          link: 'http://www.cebpubservice.com/'
        },
        {
          name: '全国公共资源交易平台',
          link: 'http://www.ggzy.gov.cn/'
        },
        {
          name: '河南省电子招标投标公共服务平台',
          link: 'http://hndzzbtb.hndrc.gov.cn/'
        },
        {
          name: '洛阳市公共资源交易中心',
          link: 'http://www.lyggzyjy.cn/'
        }
      ]
    };
  }
};
</script>
<style lang="stylus" scoped>
.bid_note_item {
  height: 28px;
  line-height: 28px;
}

.bid_link_name {
  color: #606266;
}

.bid_link_name:hover {
  color: #006980;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/bidding/link.vue